<template>
    <a href="https://apps.apple.com/app/id1572839550">
        <img class="store-badge" alt='Download on the App Store' src="../assets/app_store.svg"/>
    </a>
</template>